import React from 'react';

import { useDocumentResource } from '@/hooks/useDocumentResource';
import { documentFailureMessage } from '@/utils/documentResource';


export const DocumentFrameView = ({
  resource,
  hash = '',
  className,
  orderNumber,
  ...props
}) => {
  const result = resource;
  const objectUrl = result?.url || null;
  const failed = result && result.state !== 'loading' && result.state !== 'available';

  if (failed) {
    return <div className={`${className || ''} flex flex-col items-center justify-center gap-2 text-sm text-red-700`} {...props}>
      <span role="status">{documentFailureMessage(result)}</span>
      <button type="button" onClick={resource.retry} className="underline">Retry original document</button>
    </div>;
  }
  if (!objectUrl) {
    return <div className={`${className || ''} flex items-center justify-center text-sm text-stone-500`} {...props}>Loading source document…</div>;
  }
  // `hash` (e.g. "#view=FitH") lets a caller pass PDF open parameters so the
  // browser viewer fits the page to the frame width and reflows on resize.
  return (
    <div className={`${className || ''} flex min-h-0 flex-col`}>
      {resource.offline && (
        <div className="flex-shrink-0 border-b border-amber-200 bg-amber-50 px-3 py-1.5 text-xs font-medium text-amber-900" data-testid="offline-document-context">
          {orderNumber ? `Order ${orderNumber} — ` : ''}Offline copy — original document, unstamped
        </div>
      )}
      <iframe
        src={hash ? `${objectUrl}${hash}` : objectUrl}
        className="min-h-0 w-full flex-1 border-0"
        {...props}
      />
    </div>
  );
};

const AuthenticatedDocumentFrame = ({ url, documentKey, orderNumber, ...props }) => {
  const resource = useDocumentResource({ url, documentKey, orderNumber });
  return <DocumentFrameView resource={resource} orderNumber={orderNumber} {...props} />;
};

export default AuthenticatedDocumentFrame;
